const Dams = {
  title: "سد ها",
  chart: "DamChart",
  values: [
    { value: "رودخانه" },
    { value: "نام سد" },
    { value: "مصارف کشاورزی" },
    { value: "مصارف شرب" },
    { value: "مصارف صنعت" },
    { value: "رهاسازی دریاچه" },
    { value: "ورودی" },
    { value: "حجم مخزن" },
  ],
  colors: [
    "#f3faf9",
    "#f4faf3",
    "#f9f3fa",
    "#faf9f3",
    "#f9f3fa",
    "#f3f8fa",
    "#f4f3fa",
    "#faf9f3",
  ],
  widths: [
    "150px",
    "140px",
    "100px",
    "150px",
    "120px",
    "120px",
    "140px",
    "140px",
  ],
  totalWidth: 1070,
  items: {
    name: 0,
    latest_update_real: {
      usage_farming_current_year: 1,
      usage_drinking_current_year: 2,
      usage_industrial_current_year: 3,
      usage_other_current_year: 4,
      input_current_year: 5,
      volume_current_year: 7,
    },
  },
};

const WeatherStation = {
  title: "ایستگاه هواشناسی",
  chart: "Chart/WeatherStation",
  values: [
    { value: "نام ایستگاه" },
    { value: "کد ایستگاه" },
    { value: "بارش" },
    { value: "عمق برف" },
    { value: "چگالی برف" },
    { value: "ارتفاع برف" },
    // { value: "دمای حداقل" },
    // { value: "دمای متوسط" },
    // { value: "دمای حداکثر" },
    { value: "تبخیر" },
  ],
  colors: [
    "#f3faf9",
    "#f9f3fa",
    "#f5f3fa",
    "#faf3f4",
    "#faf9f3",
    "#f4faf3",
    // "#f9f3fa",
    // "#f4f3fa",
    // "#f3f8fa",
    "#faf3f9",
  ],
  widths: [
    "200px",
    "100px",
    "70px",
    "100px",
    "100px",
    "100px",
    // "100px",
    // "100px",
    // "100px",
    "100px",
  ],
  totalWidth: 930,
  items: {
    name: 0,
    code: 1,
    latest_update_rain: {
      value: 2,
    },
    latest_update_evp: {
      value: 9,
    },
  },
};

const Synoptic = {
  title: "ایستگاه سینوپتیک",
  chart: "Chart/Synoptic",
  values: [
    { value: "محل ایستگاه" },
    { value: "نام" },
    { value: "کد" },
    { value: "سرعت باد" },
    { value: "جهت باد" },
    { value: "رطوبت نسبی" },
    // { value: "دمای هوا" },
    { value: "بارش" },
    { value: "دمای کمینه" },
    { value: "دمای متوسط" },
    { value: "دمای بیشینه" },
  ],
  colors: [
    "#f3faf9",
    "#f9f3fa",
    "#f5f3fa",
    "#faf3f4",
    "#f4faf3",
    "#f9f3fa",
    "#f4f3fa",
    "#f3f8fa",
    "#f4f3fa",
    "#f3f8fa",
    "#f3f8fa",
  ],
  widths: [
    "200px",
    "100px",
    "80px",
    "100px",
    "100px",
    "120px",
    "120px",
    "100px",
    "100px",
    "100px",
  ],
  totalWidth: 1070,
  items: {
    name: 3,
    code: 2,
    location: 0,
    latest_update: {
      relative_humidity: 6,
      wind_speed_knots: 4,
      wind_direction_degree: 5,
      medium_temp: 7,
    },
  },
};

const Hydrometric = {
  title: "ایستگاه هیدرومتریک",
  chart: "Chart/Hydrometric",
  values: [
    { value: "رودخانه" },
    { value: "نام" },
    { value: "کد" },
    { value: "دبی" },
  ],
  colors: ["#f3faf9", "#f9f3fa", "#f5f3fa", "#faf3f4"],
  widths: ["160px", "200px", "100px", "100px"],
  totalWidth: 850,
  items: {
    name: 3,
    code: 2,
    // river: 0,
    river_eng: 0,
    latest_update: {
      discharge: 1,
    },
  },
};
const Aquifer = {
  title: "ایستگاه هیدرومتریک",
  chart: "Chart/Hydrometric",
  values: [
    { value: "رودخانه" },
    { value: "نام" },
    { value: "کد" },
    { value: "دبی" },
  ],
  colors: ["#f3faf9", "#f9f3fa", "#f5f3fa", "#faf3f4"],
  widths: ["160px", "200px", "100px", "100px"],
  totalWidth: 850,
  items: {
    name: 3,
    code: 2,
    // river: 0,
    river_eng: 0,
    latest_update: {
      discharge: 1,
    },
  },
};

export const types = {
  Dams: Dams,
  WeatherStation: WeatherStation,
  Synoptic: Synoptic,
  Hydrometric: Hydrometric,
  Aquifer: Aquifer,
};
